/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./manage-calendar.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./manage-calendar.component";
var styles_ManageCalendarComponent = [i0.styles];
var RenderType_ManageCalendarComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ManageCalendarComponent, data: {} });
export { RenderType_ManageCalendarComponent as RenderType_ManageCalendarComponent };
export function View_ManageCalendarComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" manage-calendar works!\n"]))], null, null); }
export function View_ManageCalendarComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-manage-calendar", [], null, null, null, View_ManageCalendarComponent_0, RenderType_ManageCalendarComponent)), i1.ɵdid(1, 114688, null, 0, i2.ManageCalendarComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ManageCalendarComponentNgFactory = i1.ɵccf("app-manage-calendar", i2.ManageCalendarComponent, View_ManageCalendarComponent_Host_0, {}, {}, []);
export { ManageCalendarComponentNgFactory as ManageCalendarComponentNgFactory };
